import { Component, Inject, Input, OnInit, ViewChild } from "@angular/core";
import {
  DataStateChangeEventArgs,
  GridComponent,
} from "@syncfusion/ej2-angular-grids";
import { ToastrService } from "ngx-toastr";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { GlobalComponent } from "src/app/global/global.component";
import { ColumnChangeBO, columnWidth } from "../../icd10/icd10.model";
import { AuthorizationUtilizationBO, ClientAuthorizationReportBo, PageIdentifyBo, UtilizationBO } from "../../client-parent/client-parent.model";
import { clientinactiveservice } from "./client-report-inactive.service";

@Component({
  selector: "app-client-report-inactive",
  templateUrl: "./client-report-inactive.component.html",
})
export class ClientReportInactiveComponent implements OnInit {
  @ViewChild("gridAuthorization") public gridAuthorization: GridComponent;
  id: number = 0;
  isUtilization:boolean=false;
  AuthorizationReporttype: string;
  initialPage: object;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  private onDestroy$: Subject<void> = new Subject<void>();
  arraycol: any = [];
  UtilizationList: any = [];
  AuthorizationList: any = [];
  isCheckGenerate: boolean = false;
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  ColumnArrayData: columnWidth[];
  public formatDateandTimeOptions: object;
  UtilizationDateFilterType: string = "CURRENTDATE"
  public formatOptions: object;
  initialUtilizationPage: object;
  filterSettings: object;
  pageitem: any;
  AuthorizationReportBo: ClientAuthorizationReportBo = new ClientAuthorizationReportBo();
 public data: Observable<DataStateChangeEventArgs>;
  constructor(
     @Inject(clientinactiveservice) public clientinactiveservice: clientinactiveservice,
    public global: GlobalComponent,
    public toastrService: ToastrService,
  ) {
    this.data = clientinactiveservice;
  }
  locationId: string = "00000000-0000-0000-0000-000000000000";
  ngOnInit(): void {
    this.filterSettings = { type: "Menu" };
    this.formatOptions = { type: "date", format: "MM/dd/yyyy" };
    let pag = 10;
    this.initialPage = { pageSizes: ['10', '15', '20', '50', '100', '250'], pageSize: pag }
    this.getAuthorizationReportFilter();
  }

  //..........................................onComplete.........................................
  public onComplete(args) {
    this.AuthorizationReportBo.currentpageno =
      this.gridAuthorization.pagerModule.pagerObj.currentPage;
    this.AuthorizationReportBo.pageitem =
      this.gridAuthorization.pagerModule.pagerObj.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.AuthorizationReportBo.type = args.columnType;
    }
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.gridAuthorization.columns.forEach((element) => {
        if (
          element.visible == false &&
          element.headerText != "Actions" &&
          element.headerText != ""
        ) {
          hidearr.push(element.headerText);
        }
        if (
          element.visible == true &&
          element.headerText != "Actions" &&
          element.headerText != ""
        ) {
          showarr.push(element.headerText);
        }
      });
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        this.arraycol[0].AuthorizationReport.ShowColumns.forEach((old) => {
          showarr.forEach((element) => {
            if (old == element) {
              count1 = count1 + 1;
            }
          });
        });
        this.arraycol[0].AuthorizationReport.HideColumns.forEach((old) => {
          hidearr.forEach((element) => {
            if (old == element) {
              count = count + 1;
            }
          });
        });
        if (
          this.arraycol[0].AuthorizationReport.ShowColumns.length != count1 ||
          this.arraycol[0].AuthorizationReport.HideColumns.length != count
        ) {
          this.arraycol[0].AuthorizationReport.ShowColumns = showarr;
          this.arraycol[0].AuthorizationReport.HideColumns = hidearr;
        //   this.SaveColumnwidth();
        }
      }
    }
  }
  //..........................................dataStateChange........................................
  public dataStateChange(state): void {
    this.AuthorizationReporttype = state.action.requestType.toString();
    if (this.AuthorizationReporttype != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.AuthorizationReportBo.orderColumn = state.sorted[0].name;
        this.AuthorizationReportBo.orderType =
          state.sorted[0].direction === "descending" ? "DESC" : "ASC";
      }
    }
    if (
      this.AuthorizationReporttype == "filtering" &&
      state.action.action != "clearFilter"
    ) {
      this.AuthorizationReportBo.field = state.action.currentFilterObject.field;
      this.AuthorizationReportBo.matchCase = false;
      this.AuthorizationReportBo.operator =
        state.action.currentFilterObject.operator;
      this.AuthorizationReportBo.value =
        state.action.currentFilterObject.value.toString();
    } else {
      if (
        this.AuthorizationReporttype == "filtering" &&
        state.action.action == "clearFilter"
      ) {
        this.AuthorizationReportBo.field = "clientName";
        this.AuthorizationReportBo.matchCase = false;
        this.AuthorizationReportBo.operator = "startswith";
        this.AuthorizationReportBo.value = "";
        this.AuthorizationReportBo.type = "string";
      }
    }
    if (
      this.AuthorizationReporttype == "paging" &&
      state.action.name == "actionBegin"
    ) {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].AuthorizationReport.Pagesize != state.take) {
          this.arraycol[0].AuthorizationReport.Pagesize = state.take;
        }
      }
    }

    this.getAuthorizationReportFilter();
  }

  //..........................................showColumn.........................................
  showColumn() {
    this.gridAuthorization.columnChooserModule.openColumnChooser(200, 50);
  }
  //..........................................onResize........................................
  onResize(args) {
    if (this.ColumnArrayData != undefined && this.ColumnArrayData != null) {
      const column = this.gridAuthorization.getColumnByField(args.column.field);
      column.width = args.column.width;
      this.ColumnArrayData.forEach((element) => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
    }
  }
  //..........................................getAuthorizationReportFilter.........................................
  getAuthorizationReportFilter() {
    this.AuthorizationReportBo.locationID = this.locationId;
      this.clientinactiveservice.execute(this.AuthorizationReportBo);
      this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.AuthorizationList = data.result;
        if (data.result.length > 15) {
          this.gridAuthorization.height = "500";
        } else {
          this.gridAuthorization.height = "auto";
        }
      });
  }

  //..........................................ngOnDestroy.........................................
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
